import { broadcastSessionEvents } from '@/lib/cross-tab-sync';
import { getSupabase } from '@/lib/supabase';
import type { SessionEvent, SessionId } from '@/schemas';
import { decodeRowToEvent, type EventRow } from './sync/codec';

export interface RealtimeSubscription {
  unsubscribe: () => void;
}

export async function subscribeToSession(
  sessionId: SessionId,
  onEvent: (e: SessionEvent) => void,
): Promise<RealtimeSubscription> {
  const client = getSupabase();
  const {
    data: { session },
  } = await client.auth.getSession();
  if (!session?.user) {
    throw new Error('User must be authenticated to subscribe to realtime events');
  }

  const channel = client
    .channel(`session:${sessionId}`)
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'session_events',
        filter: `session_id=eq.${sessionId}`,
      },
      (payload: { new: EventRow }) => {
        try {
          const e = decodeRowToEvent(payload.new);
          onEvent(e);
          broadcastSessionEvents([e]);
        } catch (error) {
          console.warn('Failed to decode realtime event', error);
        }
      },
    )
    .subscribe();
  return {
    unsubscribe: () => {
      void client.removeChannel(channel);
    },
  };
}

// Re-export realtime functions for other entities
export * from './realtime/player-events';
export * from './realtime/game-definitions';
export * from './realtime/team-presets';
export * from './realtime/session-index';
export * from './realtime/player-groups';
